var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-breadcrumbs',{staticClass:"p-0 me-3 orange--text",attrs:{"small":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }